import React from 'react';
import {useNavigate} from 'react-router-dom';
import {observer} from 'mobx-react';
import {MODAL_TYPES} from '../../Modals/modalConstants';
import {useStores} from '../../../../stores';
import {useGlobalModalContext} from '../../Modals';
import {APP_ROUTES} from '../../../Router/constants';
import {Pages} from '../../../Router/types';
import styles from './styles.module.scss';
import {get2faStatus} from '../../../../utils/localStorageUtils';

const TwoFactorAuthentication: React.FC = () => {
  const {isMobileScreens} = useStores();
  const {showModal, setModalStore} = useGlobalModalContext();
  const navigate = useNavigate();

  const twoFaStatus = get2faStatus();

  const handleTwoFa = (isDeactivate: boolean): void => {
    const options = {
      isDeactivate,
      title: Pages.SETTINGS,
    };
    if (isMobileScreens) {
      setModalStore(options);
      navigate(`${APP_ROUTES[Pages.SETTINGS]}/${MODAL_TYPES.TWO_FACTOR_AUTHENTICATION_MODAL}`);
    } else {
      showModal(MODAL_TYPES.TWO_FACTOR_AUTHENTICATION_MODAL, options);
    }
  };

  return (
    <div className={styles.settingsItem}>
      <div className={styles.settingsItemContent}>
        <div className={styles.twoFaTitleWrap}>
          <div className={styles.settingsItemTitle}>Two Factor Authentication</div>
          {!twoFaStatus && <div className={styles.recommended}>Recommended</div>}
        </div>

        <div className={styles.settingsItemDescription}>
          Protect your account by setting up Two Factor Authentication for your account.
        </div>

        {twoFaStatus ? (
          <div className={styles.activeBlock}>
            <div className={styles.activeBtn}>Active</div>
            <div onClick={() => handleTwoFa(true)} className={styles.deactivateBtn}>
              Turn Off 2FA
            </div>
          </div>
        ) : (
          <div onClick={() => handleTwoFa(false)} className={styles.twoFaBtn}>
            Setup Two Factor Authentication
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(TwoFactorAuthentication);
